import { z } from 'zod';

/**
 * Why a task is in `status: 'blocked'`. Spec v4 §Task.blockReason — a
 * discriminated union over the reasons the engine can wait on.
 *
 *  - `human_in_the_loop` — a human gate is required to continue.
 *  - `awaiting_input`    — waiting on data from the client or vendor.
 *  - `scheduled`         — wait until `runAt`.
 *
 * The invariant `status === 'blocked' iff blockReason !== null` is enforced
 * at the document layer via Zod refinement (see `TaskDocumentSchema`).
 */
export const BlockReasonSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('human_in_the_loop'),
    gate: z.string().min(1).max(100),
  }),
  z.object({
    kind: z.literal('awaiting_input'),
    source: z.enum(['client', 'vendor']),
  }),
  z.object({
    kind: z.literal('scheduled'),
    runAt: z.coerce.date(),
  }),
]);

export type BlockReason = z.infer<typeof BlockReasonSchema>;
